import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { SvgIcon } from "@progress/kendo-react-common";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import * as svgIcons from "@progress/kendo-svg-icons";
import { Trans } from "react-i18next";
import { t } from "i18next";

export interface SearchModalProps {
  onClose: () => void; // Function to close the modal
  onSave: (name: string) => void; // Function to save the input value
  initialValue: string; // Initial value for the input field
  isEditing?: boolean; // Boolean to indicate if the input is disabled (editing mode)
  title: string;
}
const SearchModal = (props: SearchModalProps) => {
  const [searchName, setSearchName] = React.useState<string>(
    props.initialValue
  );
 
  // Handle input change
  const handleInputChange = (event: InputChangeEvent) => {
    setSearchName(event?.target?.value?.toString() ?? "");
  };

  // Handle save operation
  const handleSave = () => {
    props.onSave(searchName);
  };
  
  return (
    <Dialog onClose={props.onClose} title={props.title} width={400}>
      <div className="search-modal">
        <fieldset>
          <Input
            id="search-name"
            value={searchName}
            onChange={handleInputChange}
            disabled={props.isEditing}
            placeholder={t("dataLabeling.search.searchName")}
          />
        </fieldset>
        <div className="pt-4 button-group">
          <DialogActionsBar layout={"end"}>
            <Button onClick={props.onClose} themeColor={"secondary"}>
              <SvgIcon
                className="btn-icons"
                icon={svgIcons.cancelIcon}
                size="medium"
              />
              <Trans>general.cancel</Trans>
            </Button>
            <Button themeColor={"primary"} onClick={handleSave}>
              <SvgIcon
                className="btn-icons"
                icon={svgIcons.saveIcon}
                size="medium"
              />
              <Trans>general.save</Trans>
            </Button>
          </DialogActionsBar>
        </div>
      </div>
    </Dialog>
  );
};

export default SearchModal;
